import { createSlice } from '@reduxjs/toolkit';

export interface ProjectTeam {
  projectExecutive: string;
  developmentManager: string;
  developmentAssociates: string;
  investmentAssociates: string;
  constructionManager: string;
  qcqa: string;
}

const initialState: ProjectTeam = {
  projectExecutive: '',
  developmentManager: '',
  developmentAssociates: '',
  investmentAssociates: '',
  constructionManager: '',
  qcqa: '',
};

export const ProjectTeamSlice = createSlice({
  name: 'projectTeam',
  initialState,
  reducers: {
    set(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { set } = ProjectTeamSlice.actions;

export default ProjectTeamSlice.reducer;
